import util from 'preact-util';

// Age text for animals (TICKET-01813). Pure function, no stores, no JSX.
//
// util.age() from preact-util only returns the single largest unit, so a dog
// that is 5 years 10 months shows as "5 år" and reads a year too young. For
// animals one year and older we show years plus months, calendar-accurate
// ("5 år 10 mnd", or just "6 år" on the birthday). Younger animals keep the
// existing month/week/day text from util.age().
//
// Always returns a string ('' when the birth date is missing, unparseable or
// in the future), unlike util.age() which hands back a raw object in those
// cases and crashes Preact when rendered as a child.
export function animalAge(birth, deceased = new Date()) {
    if (!birth) {
        return '';
    }
    const from = util.parseInputDate(birth);
    const to = util.parseInputDate(deceased);
    if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime()) || to < from) {
        return '';
    }
    let years = to.getFullYear() - from.getFullYear();
    let months = to.getMonth() - from.getMonth();
    if (to.getDate() < from.getDate()) {
        months -= 1;
    }
    if (months < 0) {
        years -= 1;
        months += 12;
    }
    if (years < 1) {
        const text = util.age(from, to);
        return typeof text === 'string' ? text : '';
    }
    return months > 0 ? `${years} år ${months} mnd` : `${years} år`;
}
